function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { FIELD_TYPES } from "constants/template-field-type";
import ThemeConfig from "segments/core-configs/theme-config";
import FullParagraphFieldsConfig from "segments/desktop/core-components/full-paragraph/fields-config";
import ProductsTabs from "segments/desktop/core-components/products-tabs/fields-config";
const { tabs } = ProductsTabs, ProductTabsRestOfProps = _object_without_properties(ProductsTabs, [
    "tabs"
]);
const { bodyColor, titleColor, textColor, topic, mobileTextAlign, textAlign, buttonConfig } = FullParagraphFieldsConfig, restOfParagraphConfig = _object_without_properties(FullParagraphFieldsConfig, [
    "bodyColor",
    "titleColor",
    "textColor",
    "topic",
    "mobileTextAlign",
    "textAlign",
    "buttonConfig"
]);
export default {
    type: FIELD_TYPES.NESTED,
    label: "Side By Side Product Switcher With Product",
    fields: _object_spread_props(_object_spread({}, ThemeConfig), {
        reverseOrder: {
            type: FIELD_TYPES.BOOLEAN,
            label: "Reverse side by side order"
        },
        productTabs: {
            type: FIELD_TYPES.NESTED,
            label: "Product tabs",
            fields: _object_spread_props(_object_spread({}, ProductTabsRestOfProps), {
                tabs: {
                    type: FIELD_TYPES.MULTIPLE_NESTED,
                    label: "Tabs",
                    nestedConfig: {
                        type: FIELD_TYPES.NESTED,
                        fields: _object_spread_props(_object_spread({
                            productType: {
                                type: FIELD_TYPES.PRODUCTS,
                                label: "Product type"
                            }
                        }, tabs.nestedConfig.fields), {
                            fullParagraph: {
                                type: FIELD_TYPES.NESTED,
                                label: "Full paragraph",
                                fields: _object_spread_props(_object_spread({
                                    marginTop: {
                                        type: FIELD_TYPES.TEXT,
                                        label: "Margin top"
                                    }
                                }, restOfParagraphConfig), {
                                    buttonConfig: {
                                        type: FIELD_TYPES.NESTED,
                                        label: "Button",
                                        fields: {
                                            additionalText: {
                                                type: FIELD_TYPES.TEXT,
                                                label: "Additional text (monday markup supported)"
                                            }
                                        }
                                    }
                                })
                            }
                        })
                    }
                }
            })
        }
    })
};
